<template>
  <div class="active-events card">
    <div v-for="(event, index) in eventArray" :key="index">
      <event-preview :event-data="event" button-label="Cancel participation" :button-action="cancelParticipation"
        :is-active="true" />
      <el-divider v-if="index < eventArray.length - 1" />
    </div>

    <div class="active-events__empty-message" v-if="eventArray.length === 0">
      There are no active events
    </div>

    <el-dialog v-model="isLeaveEventConfirmationVisible" width="30%" title="Confirmation">
      <span v-if="eventToLeave">
        Are you sure you want to leave the event «{{ eventToLeave.name }}»?
      </span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleCloseLeaveConfirmation">
            Cancel
          </el-button>
          <el-button type="primary" @click="requestLeaveEvent" :disabled="isButtonDisabled('cancel-participation')">
            Cancel participation
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import EventPreview from '@/components/events/EventPreview.vue';

import { getUserActiveEvents, leaveEvent } from '@/api/events.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'ActiveEvents',
  mixins: [disableButton],
  components: {
    EventPreview,
  },
  data() {
    return {
      eventArray: [],
      eventToLeave: null,
      isLeaveEventConfirmationVisible: false,
    };
  },
  methods: {
    showMessage,
    async fetchActiveEvents() {
      const { data, success } = await getUserActiveEvents();

      if (success) {
        this.eventArray = data.items;
      }
    },
    async requestLeaveEvent() {
      this.disableButton('cancel-participation');
      const { eventId } = this.eventToLeave;
      const { success } = await leaveEvent({ eventId });
      this.enableButton('cancel-participation');

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'You left the event',
        });
        this.handleCloseLeaveConfirmation();
        this.fetchActiveEvents();
      }
    },
    cancelParticipation(event) {
      this.eventToLeave = event;
      this.isLeaveEventConfirmationVisible = true;
    },
    handleCloseLeaveConfirmation() {
      this.isLeaveEventConfirmationVisible = false;
      this.eventToLeave = null;
    },
  },
  created() {
    this.fetchActiveEvents();
  },
};
</script>

<style lang="scss">
.active-events {
  &__empty-message {
    font-size: var(--font-size-300);
  }
}
</style>
